module.exports = __webpack_public_path__ + "img/icon_guahao_01.bfa90073.png";